var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35782 1.66741C3.35735 2.58783 2.60531 3.33361 1.67807 3.33315C0.750834 3.33269 -0.000463099 2.58616 2.14173e-07 1.66574C0.000464156 0.745318 0.752513 -0.000459895 1.67975 2.12783e-07C2.60698 0.000460747 3.35828 0.746985 3.35782 1.66741ZM3.40819 4.56725H0.0503676V15H3.40819V4.56725ZM5.37251 4.56725H8.71354L8.67996 5.96717C10.0735 3.44231 16 3.25065 16 8.39203V15H12.6842V9.5253C12.6842 6.19216 8.67996 6.47547 8.67996 9.5253V15H5.37251V4.56725Z",
    fill: "#687497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.dcd0d0eb.svg";
export { ForwardRef as ReactComponent };